<div class="ui modal"
     id="printCloseBoxTable"
     style="font-family:'Arial Narrow';">

  <h3 style="padding-right:10px;">{{this.tournamentsService.closeCashBoxBranch.Affiliate}}
    ({{this.tournamentsService.closeCashBoxBranch.AffiliateID}})</h3>
  <h3 style="padding-right:10px;">{{"Cashier" | t}} :{{this.tournamentsService.closeCashBoxBranch.Cashier}}
    ({{this.tournamentsService.closeCashBoxBranch.CashierID}})</h3>
  <h3 style="padding-right:10px;">{{"ReportNo" | t}} :{{this.tournamentsService.closeCahBoxList[0]?.ReportNo}}</h3>
  <p id="cashboxclose_p"
     style="padding-right:10px;font-size:11px">{{"Period" | t}} {{this.tournamentsService.closeCahBoxList[0]?.Period}}</p>
  <table class="cashboxclose_table"
         style="font-family:'Arial Narrow';width:100%;padding-right:10px;border-spacing:0">
    <tbody>
    <tr *ngFor="let cashbox of this.tournamentsService.closeCahBoxList">
      <td class="column_title cashboxclose_td "
          style="width:50%">{{cashbox.TransactionType}}</td>
      <td class="column_amount cashboxclose_td"
          style="text-align:right;width:50%">{{cashbox.Amount}}</td>
    </tr>


    <tr class="cashboxclose_total"
        style="font-weight:bold;width:100%">
      <td class="cashboxclose_title cashboxclose_td"
          style="width:50%;border: 2px solid;border-right: 0;">{{"Total" | t}} </td>
      <td class="cashboxclose_amount cashboxclose_td"
          style="text-align:right;width:50%;border: 2px solid;border-left: 0;">{{this.tournamentsService.closeCahBoxList[0]?.Balance}}</td>
    </tr>
    </tbody>
  </table>
</div>
<div class="ui modal"
     id="printCheckBoxTable"
     style="font-family:'Arial Narrow';">

  <ng-container *ngIf="this.systemName == 'bet3000'">
    <div style="text-align:center">
      <img src="../../Images/Logo_B3000Black.jpg"
           style="width:170px;height:55px"/>
    </div>
  </ng-container>


  <h5 style="padding-right:10px;text-transform:uppercase;">{{"CheckCashBox" | t}}</h5>
  <h5 style="padding-right:10px;">{{this.tournamentsService.checkCashBoxBranch.Affiliate}}
    ({{this.tournamentsService.checkCashBoxBranch.AffiliateID}})</h5>
  <h5 style="padding-right:10px;">{{"Cashier" | t}} :{{this.tournamentsService.checkCashBoxBranch.Cashier}}
    ({{this.tournamentsService.checkCashBoxBranch.CashierID}})</h5>
  <h5 style="padding-right:10px;">{{"ReportNo" | t}} :{{this.tournamentsService.checkCashBoxList[0]?.ReportNo}}</h5>
  <p id="cashboxclose_p"
     style="padding-right:10px;font-size:10px">{{"Period" | t}}
    {{this.tournamentsService.checkCashBoxList[0]?.Period}}</p>
  <table class="cashboxclose_table"
         style="font-family:'Arial Narrow';width:100%;padding-right:10px;border-spacing:0">
    <tbody>
    <tr *ngFor="let cashbox of this.tournamentsService.checkCashBoxList; let last = last;">
      <td [ngStyle]="{'font-weight' : last == true ? 'bold' : 'normal' , 'border' : last == true ? '2px solid' :
      'none', 'border-right' : '0', 'width' : '50%', 'font-size' : '12px'}"
          class="cashboxclose_title cashboxclose_td ">{{cashbox.TransactionType}}</td>
      <td [ngStyle]="{'font-weight' : last == true ? 'bold' : 'normal' , 'border' : last == true ? '2px solid' :
      'none', 'border-left' : '0', 'width' : '50%', 'text-align' : 'right', 'font-size' : '12px'}"
          class="column_amount cashboxclose_td">{{cashbox.Amount}}</td>
    </tr>

    <!-- BET 3000 için kaldırıldı. Gerekirse sonradan aç-->
    <!--      <tr class="cashboxclose_total" style="width:100%">-->
    <!--        <td class="cashboxclose_title cashboxclose_td" style="width:50%">{{"Total" | t}} </td>-->
    <!--        <td class="cashboxclose_amount cashboxclose_td" style="text-align:right;width:50%">{{this.tournamentsService.checkCashBoxList[0]?.Balance}}</td>-->
    <!--      </tr>-->
    </tbody>
  </table>
</div>
<style>

  .cashboxclose_table {
    width: 100%;
    margin: 0;
    padding: 0;
    border-collapse: collapse;
    border-top: 1px solid #000000;
    border-right: 1px solid #000000;
    font: normal 12px/16px Arial, Helvetica, sans-serif;
  }

  .cashboxclose_td {
    padding: 6px;
    color: #000;
    border-bottom: 1px solid #000000;
    border-left: 1px solid #000000;
    font-size: 12px !important;
  }


  /*.cashboxclose_total {
    font-weight: bold;
    border: 2px solid black;
  }*/


  .cashboxclose_amount {
    width: 40px;
    text-align: right;
  }

  .cashboxclose_title {
    width: 60px;
  }


  #cashboxclose_p {
    font: normal 16px/16px Arial, Helvetica, sans-serif;
  }
</style>
